import { useEffect } from "react";
import { useApp } from "../../../context/AppContextProvider";
import i18n from "../../../language/i18n";
import ErrorLayout from "../../../components/common/error/ErrorLayout";

const ServerUnreachableErrorScreen = () => {
  const { isFullScreen, setIsFullScreen } = useApp();

  useEffect(() => {
    if (isFullScreen === false) {
      setIsFullScreen(true);
    }
  }, []);

  return (
    <ErrorLayout
      statusText={i18n.t("server_unreachable_status_text")}
      tone="info"
      icon="gear"
    />
  );
};

export default ServerUnreachableErrorScreen;
